import type { Locale } from '@/i18n/locales';

/** Translated article data may contain an old lang=en; the page owns its locale. */
export function guideHrefForLocale(href: string, locale: Locale): string {
  if (!href.startsWith('/') || href.startsWith('//')) return href;
  const url = new URL(href, 'https://guide.invalid');
  if (url.origin !== 'https://guide.invalid') return href;
  // Public English content keeps its canonical clean URL. Creation entrypoints
  // carry an explicit locale so a saved account preference cannot override it.
  const creationEntry = /^\/(?:explore|login|t(?:\/|$))/.test(url.pathname);
  if (locale === 'en' && !creationEntry) url.searchParams.delete('lang');
  else url.searchParams.set('lang', locale);
  return `${url.pathname}${url.search}${url.hash}`;
}
